import React from 'react'
import { Link } from 'react-router'
import GenericEvent from './GenericEvent'

const CONVERSATION_ICON_SRC = require('images/svg/conversation-navy.svg')

function truncate(string, n){
  if (!string) return ''
  return (string.length > n) ? `${string.substr(0, n - 1)}...` : string
}

const ConversationEvent = props => {
  const { conversation } = props.event.body
  const eventProps = {
    iconSrc: CONVERSATION_ICON_SRC,
    eventLabel: 'started a conversation',
    ...props,
  }
  return (
    <GenericEvent {...eventProps }>
      <div style={{ margin: '0.25rem 0' }}>
        <Link to={`/inboxes/${ conversation.inboxId }/conversations/${conversation.id}`}>
          <span className="dsg-medium-weight">{`#${conversation.displayId}`}</span>
        </Link>&nbsp;
        <span className="color-navy-dark">|</span>&nbsp;
        &ldquo;{truncate(conversation.preview, 100)}&rdquo;
      </div>
    </GenericEvent>
  )
}

export default ConversationEvent



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/ConversationEvent.js